import { BaseModel } from 'core/models/base.model.js';

export var CalendaccVascoModel = BaseModel.extend({

  idAttribute: "id"
});